import React, {useEffect, useState} from "react";
import './Home.css';
import logo from "../../assets/images/schmodelplain-withR-white.png";
import club_shop_studio from "../../assets/images/club_shop_studio.png";
import LogoDropDown from "../LogoDropDown/logoDropDown";

function HomeCom() {
    const [showLogo, setShowLogo] = useState(true);

    useEffect(() => {
        const fadeTimer = setTimeout(() => setShowLogo(false), 4000);
        return () => clearTimeout(fadeTimer);
    }, []);

    return (
        <div className="home-container">
            {showLogo && <>
                <img src={logo} className="fade-in-out schmodel-com-logo" alt="logo" />
                <div className="fade-in-out absolute p-10 bottom-0 right-0 flex flex-col justify-center items-end text-lg">
                    <img src={club_shop_studio} style={{width: '65px'}} alt="club_shop_studio" />
                </div>
            </>}
            {!showLogo && <>
                <div className="com-container">
                    <div className='com-header'>
                        <LogoDropDown activeItems={["Schmodel", ".shop", ".club"]} animation={true} />
                    </div>
                    <div className="com-main">
                        <p className="fade-in slogan">The global community of <br/>
                            fashion, beauty & luxury
                        </p>
                    </div>
                    <div className="com-footer"/>
                </div>
            </>}
        </div>
    );
}

export default HomeCom;
